import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import TextInput, { IInputProps as IProps } from '../TextInput';
import appConfig from '../../configs/app.json';

const validRegex = /^.*(?=.*[a-zA-Z])(?=.*[\d]).*$/;

function passwordValidation(password: string) {
  return (
    validRegex.test(password) &&
    Boolean(password.length >= appConfig.passwordMinLength)
  );
}

export default function PasswordInput(props: IProps): ReactElement {
  const { placeholder, message, validation } = props;

  const { t } = useTranslation();

  return (
    <TextInput
      {...props}
      type="password"
      placeholder={placeholder || t('PasswordInput.placeholder')}
      validation={validation || passwordValidation}
      message={
        message ||
        t('PasswordInput.warningMessage', {
          passwordMinLength: appConfig.passwordMinLength
        })
      }
      autoComplete="off"
    />
  );
}
